<template>
    <div class="ku-foot-tab">
        <van-button type="primary" :class="tabKey === 'out_order' ? 'active' : ''" url="/out_order">外卖订单</van-button>
        <van-button type="primary" :class="tabKey === 'order' ? 'active' : ''" url="/order">堂食订单</van-button>
        <van-button type="primary" :class="tabKey === 'report' ? 'active' : ''" url="/report">资金</van-button>
        <van-button type="primary" :class="tabKey === 'food' ? 'active' : ''" url="/food">菜品</van-button>
        <van-button type="primary" :class="tabKey === 'index' ? 'tab_index active' : 'tab_index'" @click="show_tab_index = !show_tab_index">{{shopName}}</van-button>
        <transition>
            <div class="popup popup-index" v-show="show_tab_index">
                <van-button block type="primary" class="s2" url="/">首页</van-button>
<!--                <van-button block type="primary" class="s2" :class="{active: headKey === 'qrcode'}" url="/qrcode">店铺桌码</van-button>-->
<!--                <van-button block type="primary" class="s2" :class="{active: headKey === 'for_here'}" url="/forHere">外送设置</van-button>-->
                <van-button block type="primary" class="s2" :class="{active: headKey === 'index'}" url="/shop">设置</van-button>
                <van-button block type="primary" v-for="(item, index) in shopInfo" :key="index" class="s2" v-show="shop_id != item.id" @click="showMap(item)">{{ item.shop_name }}</van-button>
            </div>
        </transition>
    </div>
</template>

<script>
import Vue from 'vue'
import { Button } from 'vant'
import {getCookie, setShop} from '@/utils/auth'

Vue.use(Button)
export default {
    name: "foot",
    data() {
        return {
            show_tab_index: false,
            shop_id: 0,
            shopInfo: [],
            shopName: '',
        }
    },
    props: {
        tabKey: {
            type: String,
            default: ''
        },
        headKey: {
            type: String,
            default: ''
        }
    },
    mounted() {
        let that = this
        that.shopInfo = JSON.parse(getCookie('shopInfo'))
        that.shop_id  = getCookie('shop_id')
        that.shopName = getCookie('ShopName')

      //
      document.addEventListener('click',function(e){
        if (e.target.className.indexOf('tab_index') === -1) {
            that.show_tab_index = false
        }
      })
    },
    methods: {
        showMap(res) {
            setShop(res)
            this.$router.go(0)
        },
    }
}
</script>

<style lang="less" scoped>
.ku-foot-tab {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    .van-button {
        height: 80px;
        width: 18%;
        padding: 0;
        background: #26A670;
        border-color: #26A670 #26A670 #26A670 #fff;
        border-radius: 5px;
        font-size: 28px;
        &:nth-child(1) {
            border-left-color: #26A670;
        }
        &:nth-child(5),
        &.tab_index {
            width: 28%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: left;
            padding: 0 8px;
            font-size: 28px;
        }
        &.active {
            background: #E68925;
            border-color: #E68925 #E68925 #E68925 #fff;
            &:nth-child(1) {
                border-left-color: #E68925;
            }
        }
    }
    .popup {
        width: 28%;
        position: absolute;
        z-index: 2;
        &.popup-index {
            right: 0;
            bottom: 80px;
        }
        .van-button {
            width: 100%;
            height: 80px;
            line-height: 80px;
            margin-bottom: 2px;
            overflow: hidden;
            text-overflow:ellipsis;
            white-space: nowrap;
            &.s1 {
                background: #534942;
                border-color: #534942;
            }
            &.s2 {
                background: #B9926C;
                border-color: #B9926C;
                &.active {
                    color: #FFFF00;
                }
            }
        }
    }
}
</style>
